import { Component } from '@angular/core';
import { ImageService } from 'src/app/services/image/image.service';
import { environment } from 'src/environments/environment';
import { EvaluatedLinkdinService } from './service/evaluated-linkdin.service';

@Component({
  selector: 'app-evaluatedlinkdin',
  templateUrl: './evaluatedlinkdin.component.html',
  styleUrls: ['./evaluatedlinkdin.component.css'],
})
export class EvaluatedlinkdinComponent {
  constructor(
    private evaluatedlinkdinService: EvaluatedLinkdinService,
    private imageService: ImageService
  ) {}
  imagePath = environment.apiUrl;
  evaluatedProfiles = [];
  selectedprofile: any = null;
  ngOnInit(): void {
    this.evaluatedlinkdinService
      .getEvaluatedLinkdinProfiles()
      .subscribe((evaluatedLinkdin: any) => {
        this.evaluatedProfiles = evaluatedLinkdin;
      });
  }
  getProfileScanDetails(profile: any) {
    this.selectedprofile = profile;
  }
  getImagePath(profile: any) {
    let fullImagePath = this.imageService.getImagePath(profile.linkedinImage);
    return this.imageService.updateImageUrl(fullImagePath);
  }
}
